import { injectIntl } from 'react-intl';
import IdentityVerificationBNC from './IdentityVerificationBNC';
import config from './config';
import * as validation from './validation';

export const VALIDATION = validation;
export const CONFIG = config;

export default injectIntl(IdentityVerificationBNC);
